import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { PasswordInput, Field } from "@/components/common";
import { AuthShell } from "@/pages/Login";
import { useLang } from "@/lib/i18n";
import { api, errMsg } from "@/lib/api";

export default function ResetPassword() {
  const { t } = useLang();
  const [sp] = useSearchParams();
  const [f, setF] = useState({ a: "", b: "" });
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");
  const submit = async (e) => {
    e.preventDefault();
    if (f.a !== f.b) return setErr(t("pw_mismatch"));
    try { await api.post("/auth/reset-password", { token: sp.get("token") || "", password: f.a }); setDone(true); } catch (e2) { setErr(errMsg(e2)); }
  };
  return (
    <AuthShell title={t("reset_title")} testid="reset-page">
      {done ? <p className="rounded-xl bg-green-50 p-4 text-sm text-green-800" data-testid="reset-success">{t("reset_done")}</p> : (
        <form onSubmit={submit} className="grid gap-4">
          <Field label={t("password")} hint={t("pw_hint")}><PasswordInput required minLength={8} value={f.a} onChange={(e) => setF({ ...f, a: e.target.value })} testid="reset-password-input" /></Field>
          <Field label={t("confirm_pw")}><PasswordInput required minLength={8} value={f.b} onChange={(e) => setF({ ...f, b: e.target.value })} testid="reset-confirm-input" /></Field>
          {err && <p className="text-sm text-red-600" data-testid="reset-error">{err}</p>}
          <button className="h-12 rounded-full bg-[#FF6B00] font-bold text-white hover:bg-[#E05A00]" data-testid="reset-submit-btn">{t("reset_btn")}</button>
        </form>
      )}
      <Link to="/login" className="mt-6 block text-center text-sm font-bold text-[#142B5C]" data-testid="reset-back-login">{t("back_login")}</Link>
    </AuthShell>
  );
}
